import styled from 'styled-components'

export default styled.hr`
  background: rgba(107, 106, 131, 0.2);
`
